import { ImagePreviewStatus } from 'components/ImagePreview';

export enum ScanStepsEnum {
  capture = 0,
  preview = 1,
  endOfTheFlow = 2,
}

export interface ScanState {
  step: ScanStepsEnum;
  imageStatus?: ImagePreviewStatus;
  imageUploadProgress?: number;
  imageErrorMessage?: string;
  imageErrorLabel?: string;
  image?: string;
  imagePreview?: string;
  focusQuality?: number;
  focusQualityThreshold?: number;
  file?: File;
}

export enum ScanActionTypes {
  NEXT_STEP,
  PREVIOUS_STEP,
  SET_IMAGE_STATUS,
  SET_IMAGE_UPLOAD_PROGRESS,
}

interface ScanActionPayload {
  type: ScanActionTypes;
  payload: any;
}

export const initialState: ScanState = {
  step: ScanStepsEnum.capture,
};

export function nextStepAction(
  mainImageData?: {
    mainImage: string;
    focusQuality: number;
    focusQualityThreshold: number;
    file?: File;
  },
  previewImage?: string
) {
  return {
    type: ScanActionTypes.NEXT_STEP,
    payload: {
      mainImage: mainImageData?.mainImage,
      previewImage,
      focusQuality: mainImageData?.focusQuality,
      focusQualityThreshold: mainImageData?.focusQualityThreshold,
      file: mainImageData?.file,
    },
  };
}

export function previousStepAction() {
  return {
    type: ScanActionTypes.PREVIOUS_STEP,
    payload: null,
  };
}

export function setImageStatusAction(
  imageStatus: ImagePreviewStatus,
  imageErrorMessage?: string,
  imageErrorLabel?: string
) {
  return {
    type: ScanActionTypes.SET_IMAGE_STATUS,
    payload: { imageStatus, imageErrorMessage, imageErrorLabel },
  };
}

export function setImageUloadProgressAction(imageUploadProgress: number) {
  return {
    type: ScanActionTypes.SET_IMAGE_UPLOAD_PROGRESS,
    payload: imageUploadProgress,
  };
}

export function reducer(
  state: ScanState,
  action: ScanActionPayload
): ScanState {
  switch (action.type) {
    case ScanActionTypes.NEXT_STEP:
      switch (state.step) {
        case ScanStepsEnum.capture:
          return goToPreviewStep(state, action);
          break;

        case ScanStepsEnum.preview:
          return goToEndOfTheFlow(state);
          break;

        default:
          return state;
          break;
      }
      break;

    case ScanActionTypes.PREVIOUS_STEP:
      return {
        ...state,
        step: (state.step - 1) as ScanStepsEnum,
        imageStatus: undefined,
        imageErrorMessage: undefined,
        image: undefined,
        imagePreview: undefined,
      };

    case ScanActionTypes.SET_IMAGE_STATUS:
      return {
        ...state,
        imageStatus: action.payload.imageStatus,
        imageErrorMessage: action.payload.imageErrorMessage,
        imageErrorLabel: action.payload.imageErrorLabel,
      };

    case ScanActionTypes.SET_IMAGE_UPLOAD_PROGRESS:
      return {
        ...state,
        imageUploadProgress: action.payload,
      };

    default:
      return state;
  }
}

function goToPreviewStep(
  state: ScanState,
  action: ScanActionPayload
): ScanState {
  return {
    ...state,
    step: ScanStepsEnum.preview,
    image: action.payload.mainImage,
    imagePreview: action.payload.previewImage,
    imageStatus: ImagePreviewStatus.UPLOADING,
    imageErrorMessage: undefined,
    focusQuality: action.payload.focusQuality,
    focusQualityThreshold: action.payload.focusQualityThreshold,
    file: action.payload.file,
  };
}

function goToEndOfTheFlow(state: ScanState): ScanState {
  return {
    ...state,
    step: ScanStepsEnum.endOfTheFlow,
  };
}
